var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.25 8.25C13.25 7.55964 12.6904 7 12 7C11.3096 7 10.75 7.55964 10.75 8.25V10.75H8.25C7.55964 10.75 7 11.3096 7 12C7 12.6904 7.55964 13.25 8.25 13.25H10.75V15.75C10.75 16.4404 11.3096 17 12 17C12.6904 17 13.25 16.4404 13.25 15.75V13.25H15.75C16.4404 13.25 17 12.6904 17 12C17 11.3096 16.4404 10.75 15.75 10.75H13.25V8.25Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPlus);
export default __webpack_public_path__ + "static/media/bg-plus.3af0a4b1df18a62ea4b4af668024aeee.svg";
export { ForwardRef as ReactComponent };